export const testListsSkeleton = [
    // Heading
    {
        span: 14,
        height: "32px",
        classes: "marginTop-40",
    },

    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
    {
        span: 14,
        height: "60px",
        classes: "marginTop-16",
    },
]
